/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExpenseRequest,
  ErrorResponse,
  Expense,
} from '../models/index';
import {
    CreateExpenseRequestFromJSON,
    CreateExpenseRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ExpenseFromJSON,
    ExpenseToJSON,
} from '../models/index';

export interface CreateExpenseOperationRequest {
    createExpenseRequest: CreateExpenseRequest;
}

export interface DeleteExpenseRequest {
    id: string;
}

export interface GetAllExpensesRequest {
    projectId?: string;
    typeId?: string;
}

export interface GetExpenseByIdRequest {
    id: string;
}

export interface UpdateExpenseRequest {
    id: string;
    createExpenseRequest: CreateExpenseRequest;
}

/**
 * 
 */
export class ExpensesApi extends runtime.BaseAPI {

    /**
     * Create a new expense
     * Create a new expense
     */
    async createExpenseRaw(requestParameters: CreateExpenseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Expense>> {
        if (requestParameters['createExpenseRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseRequest',
                'Required parameter "createExpenseRequest" was null or undefined when calling createExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/expenses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseRequestToJSON(requestParameters['createExpenseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseFromJSON(jsonValue));
    }

    /**
     * Create a new expense
     * Create a new expense
     */
    async createExpense(requestParameters: CreateExpenseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Expense> {
        const response = await this.createExpenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an expense
     * Delete expense
     */
    async deleteExpenseRaw(requestParameters: DeleteExpenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expenses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an expense
     * Delete expense
     */
    async deleteExpense(requestParameters: DeleteExpenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExpenseRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all expenses
     * Get all expenses
     */
    async getAllExpensesRaw(requestParameters: GetAllExpensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Expense>>> {
        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['typeId'] != null) {
            queryParameters['typeId'] = requestParameters['typeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expenses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExpenseFromJSON));
    }

    /**
     * Retrieve a list of all expenses
     * Get all expenses
     */
    async getAllExpenses(requestParameters: GetAllExpensesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Expense>> {
        const response = await this.getAllExpensesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an expense by its ID
     * Get expense by ID
     */
    async getExpenseByIdRaw(requestParameters: GetExpenseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Expense>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getExpenseById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/expenses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseFromJSON(jsonValue));
    }

    /**
     * Retrieve an expense by its ID
     * Get expense by ID
     */
    async getExpenseById(requestParameters: GetExpenseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Expense> {
        const response = await this.getExpenseByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing expense
     * Update expense
     */
    async updateExpenseRaw(requestParameters: UpdateExpenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Expense>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateExpense().'
            );
        }

        if (requestParameters['createExpenseRequest'] == null) {
            throw new runtime.RequiredError(
                'createExpenseRequest',
                'Required parameter "createExpenseRequest" was null or undefined when calling updateExpense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/expenses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExpenseRequestToJSON(requestParameters['createExpenseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExpenseFromJSON(jsonValue));
    }

    /**
     * Update an existing expense
     * Update expense
     */
    async updateExpense(requestParameters: UpdateExpenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Expense> {
        const response = await this.updateExpenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
